import axios from "axios"
import { getHistory } from "../setup"

export const setupAxiosInterceptors = (store: any) => {
  axios.interceptors.response.use(
    (response) => response,
    (error) => {
      if (error?.response?.status === 401) {
        console.log("SESSION EXPIRED SIGNOUT")
        const alias = window.location.pathname.split("/")[1]
        store.dispatch({ type: "LOGOUT" })
        getHistory().push(`/${alias}/signin`)
      }
      return Promise.reject(error)
    }
  )
}
